import { css } from "@emotion/react";

const Abema: React.FC = () => {
  return (
    <div css={mainStyle}>
      <div css={contentsWrapperstyle}>
        <a
          href="https://abema.tv/video/title/587-3"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/logo-abema.png"}
            alt="TikTok"
            css={imgStyle}
          />
        </a>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/abema-txt-top.png"}
          css={topTxtImgStyle}
        />
        <div css={mediasWrapperStyle}>
          <div css={mediasImgWrapperStyle}>
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH +
                "/img/media/medias-background.png"
              }
              css={mediaImgStyle}
            />
            <a
              href="https://www.amazon.co.jp/gp/video/detail/B0CPTL69NK/ref=atv_dp_share_cu_r"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  "/img/media/amazon-prime-video.png"
                }
                css={mediaLeftImgStyle(30, 23)}
              />
            </a>
            <a
              href="https://fod.fujitv.co.jp/title/b0kr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH + "/img/media/fod.png"
                }
                css={mediaLeftImgStyle(41, 5.5)}
              />
            </a>
            <a
              href="https://tv.dmm.com/vod/restrict/detail/?season=p1wrk3uabxr8bejo0z4241sw9"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  "/img/media/dmm-tv.png"
                }
                css={mediaLeftImgStyle(52, 11)}
              />
            </a>
            <a
              href="https://www.videomarket.jp/title/43000W"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  "/img/media/video-market.png"
                }
                css={mediaLeftImgStyle(63, 17)}
              />
            </a>
            <a
              href="https://www.hulu.jp/sundome"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH + "/img/media/hulu.png"
                }
                css={mediaLeftImgStyle(75, 6)}
              />
            </a>
            <a
              href="https://video.unext.jp/freeword?query=すんドめ&td=SID0098361"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  "/img/media/u-next.png"
                }
                css={mediaLeftImgStyle(88, 10)}
              />
            </a>
            <a
              href="https://watcha.com/ja-JP/contents/share/tE3AW87"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  "/img/media/watcha.png"
                }
                css={mediaRightImgStyle(30, 10)}
              />
            </a>
            <a
              href="https://linkvod.myjcom.jp/video/sr00206379?type=series"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  "/img/media/jcom-stream.png"
                }
                css={mediaRightImgStyle(42.5, 20)}
              />
            </a>
            <a
              href="https://tv.rakuten.co.jp/content/465141/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  "/img/media/rakuten-tv.png"
                }
                css={mediaRightImgStyle(55, 15)}
              />
            </a>
            <a
              href="https://lemino.docomo.ne.jp/search?word=%E3%81%99%E3%82%93%E3%83%89%E3%82%81&crid=Y3JpZDovL3BsYWxhLmlwdHZmLmpwL2dyb3VwL2IxMDEyNDM%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH + "/img/media/lemio.png"
                }
                css={mediaRightImgStyle(67.5, 10)}
              />
            </a>
          </div>
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH +
              "/img/abema-medias-subtitle.png"
            }
            css={subtitleImgStyle}
          />
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#D90012";
const contentsMaxWidth = 750;
const spSize = 768;

const mainStyle = css`
  width: 100%;
  background-color: white;
`;

const contentsWrapperstyle = css`
  width: 100%;
  padding: 30px 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const imgStyle = css`
  width: 250px;

  @media (max-width: ${spSize}px) {
    width: 200px;
  }
`;

const topTxtImgStyle = css`
  width: 280px;
  margin-top: 20px;

  @media (max-width: ${spSize}px) {
    width: 220px;
  }
`;

const mediasWrapperStyle = css`
  width: 100%;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const mediasImgWrapperStyle = css`
  position: relative;
  width: 85%;
  max-width: ${contentsMaxWidth}px;
  display: flex;
`;

const mediaImgStyle = css`
  width: 100%;
  height: auto;
`;

const mediaLeftImgStyle = (top: number, width: number) => css`
  position: absolute;
  top: ${top}%;
  left: 25%;
  width: ${width}%;
  transform: translateX(-50%);
  height: auto;
`;

const mediaRightImgStyle = (top: number, width: number) => css`
  position: absolute;
  top: ${top}%;
  left: 75%;
  transform: translateX(-50%);
  width: ${width}%;
  height: auto;
`;

const subtitleImgStyle = css`
  width: 350px;
  margin-top: 20px;

  @media (max-width: ${spSize}px) {
    width: 280px;
  }
`;

export default Abema;
